import { UploadInputComponent } from './layout/upload-input/upload-input.component';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { HeaderComponent } from './layout/header/header.component';
import { SlickModule } from 'ngx-slick';
import { BuscaPacotesComponent } from './layout/busca-pacotes/busca-pacotes.component';
import { ListCardComponent } from './layout/list-card/list-card.component';
import { FooterComponent } from './layout/footer/footer.component';
import { LoadingComponent } from './layout/loading/loading.component';
import { BannerComponent } from './layout/banner/banner.component';
import { PaginationComponent } from './layout/pagination/pagination.component';
import { HightlightPipe } from './pipes/hightlight.pipe';
import { NoutFoundComponent } from './pages/nout-found/nout-found.component';
import { TrabalheConoscoComponent } from './pages/trabalhe-conosco/trabalhe-conosco.component';

import { NgxMaskModule } from 'ngx-mask';
import { NguiMapModule } from '@ngui/map';
import { TrajetosComponent } from './layout/trajetos/trajetos.component';
import { HorariosComponent } from './pages/horarios/horarios.component';
import { SobreComponent } from './pages/sobre/sobre.component';
import { NoticiasComponent } from './pages/noticias/noticias.component';
import { InternaComponent } from './pages/noticias/interna/interna.component';
import { FaleComAgenteComponent } from './pages/fale-com-agente/fale-com-agente.component';
import { TapumeComponent } from './pages/tapume/tapume.component';
import { EvolucaoTarifariaComponent } from './pages/evolucao-tarifaria';

const options = {
  dropSpecialCharacters: false
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    BuscaPacotesComponent,
    ListCardComponent,
    FooterComponent,
    LoadingComponent,
    UploadInputComponent,
    BannerComponent,
    PaginationComponent,
    HightlightPipe,
    NoutFoundComponent,
    TrabalheConoscoComponent,
    TrajetosComponent,
    HorariosComponent,
    SobreComponent,
    NoticiasComponent,
    InternaComponent,
    FaleComAgenteComponent,
    TapumeComponent,
    EvolucaoTarifariaComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    AppRoutingModule,
    NgxMaskModule.forRoot(options),
    SlickModule.forRoot(),
    NguiMapModule.forRoot({apiUrl: 'https://maps.google.com/maps/api/js?key=AIzaSyDRgLZHdvaXwcoqsupZbbMpI6poAO-KtGw'})
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
